module.exports = new __parcel__URL__("fullname-dark.0689e06a.png").toString();